import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Asset URLs ("/images/…") are root-absolute in code and in the content
// JSON; prefix them with PUBLIC_URL so they resolve when the site is
// deployed under a subdirectory ("" in dev, set at build time).
export function asset(path) {
  return typeof path === "string" && path.startsWith("/")
    ? process.env.PUBLIC_URL + path
    : path;
}
